import { render, staticRenderFns } from "./SearchTableHeader.vue?vue&type=template&id=13b28cb7&scoped=true"
import script from "./SearchTableHeader.vue?vue&type=script&lang=js"
export * from "./SearchTableHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchTableHeader.vue?vue&type=style&index=0&id=13b28cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b28cb7",
  null
  
)

export default component.exports